export default __webpack_public_path__ + "static/media/reckless-light-webfont.d060df14.ttf";